module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_3009.b13c60fa.png";